module.exports = "https://coinrabbit.io/_next/static/images/empty-e49ba9c9eaa0262b22de377ac4de8764.svg";